import CircularJSON from 'circular-json';
import { isPrimitive } from 'util';

const changeCheck = (keysToCheck, old, next) => {
  for (var i = 0; i < keysToCheck.length; i++) {
    const before = old[keysToCheck[i]];
    const after = next[keysToCheck[i]];

    if(after ? !before : before) {
      return true;
    }

    if(isPrimitive(after) && isPrimitive(before)) {
      if(after !== before) {
        return true;
      }
    }
    else if (CircularJSON.stringify(after) !== CircularJSON.stringify(before)){
      return true;
    }
  }
  return false;
};

export default changeCheck;


// WEBPACK FOOTER //
// ./src/utils/ChangeCheck.js